import React, { useEffect, useState } from "react";
import Navbar from "../header/Navbar";
import Sidebar from "../sidebar/Sidebar";
import "./style.css";
import { useLocation, useNavigate } from "react-router-dom";
import SquareAvatar from "../../commonComponent/SquareAvatar";
import ViewCareTeamBox from "./ViewCareTeamBox";
import AppointmentPatientSection from "./AppointmentPatientSection";
import TeamMemberList from "./TeamMemberList";
import CareTeamStatus from "./CareTeamStatus";
import moment from "moment";
import { getDoctors } from "../../services/DoctorService";
import { getCareTeamsforAdmin } from "../../services/CareTeam";

const initialData = {
  _id: "",
  docId: "",
  teamName: "",
  description: "",
  teamManager: "",
  status: true,
  createdAt: "",
  updatedBy: "",
  updatedAt: "",
  teamMeambers: [],
  groups: [],
  programs: [],
  teamManagerName: "",
};
const ViewCareTeam = () => {
  const [teamData, setTeamData] = useState(initialData);
  const [createdBy, setCreatedBy] = useState();
  const location = useLocation();
  const { TeamData } = location.state;
  const navigate = useNavigate();

  useEffect(() => {
    if ("description" in TeamData) {
      setTeamData(TeamData);
      renderCreatedBy(TeamData);
    } else {
      getCareTeamById();
    }
  }, []);

  const getCareTeamById = async () => {
    try {
      const response = await getCareTeamsforAdmin();
      if (response.status !== 200) return;
      setTeamData(
        response.data.data.filter((team) => team._id === TeamData.careTeamId)[0]
      );
      renderCreatedBy(
        response.data.data.filter((team) => team._id === TeamData.careTeamId)[0]
      );
    } catch (error) {
      console.log(error);
    }
  };

  const renderCreatedBy = async (TeamData) => {
    try {
      if (
        TeamData?.docId === JSON.parse(localStorage.getItem("authUser"))._id
      ) {
        setCreatedBy(JSON.parse(localStorage.getItem("authUser")));
        return;
      }
      const result = await getDoctors();

      if (result.status !== 200) return;

      let filteredMembers =
        result.data.data.filter((member) => TeamData?.docId === member._id) ??
        false;
      setCreatedBy(filteredMembers[0]);
    } catch (error) {
      console.log(error);
    }
  };

  const renderSearchHeader = () => {
    return (
      <div className="d-flex mt-5 mb-3 ">
        <div className="w-100">
          <h4 className=" headFont ">{teamData?.teamName}</h4>
          <p className="view_createdby9 mt-3 mb-3">
            <span className="span1 me-2">Created by:</span>
            <span className="span2">
              <SquareAvatar
                src={createdBy?.profilePicture}
                className="imgsize me-2"
              />
              {createdBy?.full_name}
            </span>
            <span className="span1  me-1 ms-3">Created on:</span>
            <span className="span2">
              {moment(new Date(teamData?.createdAt)).format("MMM DD,YYYY")}
            </span>
          </p>

          <p className="resFont">{teamData?.description}</p>
        </div>
      </div>
    );
  };

  return (
    <>
      <Navbar />
      <div className="container-fluid mb-5">
        <div className="row">
          <div className="col-md-2">
            <Sidebar />
          </div>
          <div className="col-md-10 py-4 px-5">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li
                  class="breadcrumb-item cursor-pointer"
                  onClick={() => navigate("/")}
                >
                  Home
                </li>
                <li
                  class="breadcrumb-item cursor-pointer"
                  onClick={() => navigate(-1)}
                >
                  Care Team
                </li>
                <li class="breadcrumb-item active fw-bold" aria-current="page">
                  {teamData?.teamName}
                </li>
              </ol>
            </nav>
            <div>
              {renderSearchHeader()}
              {teamData._id && (
                <>
                  <ViewCareTeamBox teamData={teamData} />
                  <AppointmentPatientSection teamData={teamData} />
                  <TeamMemberList teamData1={teamData} />
                </>
              )}
            </div>
          </div>
          {teamData._id && <CareTeamStatus teamData={teamData} />}
        </div>
      </div>
    </>
  );
};

export default ViewCareTeam;
